import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject, debounceTime, fromEvent, takeUntil } from "rxjs";

export interface Menu {
    headTitle1?: string;
    level?: number;
    headTitle2?: string;
    path?: string;
    title?: string;
    type?: string;
    icon?: string;
    active?: boolean;
    bookmark?: boolean;
    pinnedData?: boolean;
    items?: Menu[];
    children?: Menu[];
}

@Injectable({
    providedIn: "root",
})

export class SuperAdminNavService {
    public screenWidth: BehaviorSubject<number> = new BehaviorSubject(
        window.innerWidth
    );

    private unsubscriber: Subject<any> = new Subject();

    public language: boolean = false;

    public collapseSidebar: boolean = window.innerWidth < 1200 ? true : false;

    constructor(private router: Router) {
        this.setScreenWidth(window.innerWidth);
        fromEvent(window, "resize")
            .pipe(debounceTime(0), takeUntil(this.unsubscriber))
            .subscribe((evt: any) => {
                this.setScreenWidth(evt.target.innerWidth);
                if (evt.target.innerWidth < 1200) {
                    this.collapseSidebar = true;
                } else {
                    this.collapseSidebar = false;
                }
            });
    }

    private setScreenWidth(width: number): void {
        this.screenWidth.next(width);
    }

    MENUITEMS: Menu[] = [
        {
            level: 1,
            title: "Dashboard",
            icon: "stroke-home",
            path: '/superadmin/dashboard',
            type: "link",
            active: true,
        },
        {
            level: 1,
            title: "Superadmin",
            icon: "stroke-user",
            path: '/superadmin/superadmin',
            type: "link",
            active: false,
        },
        {
            level: 1,
            title: "Companies",
            icon: "stroke-building",
            path: '/superadmin/companies',
            type: "link",
            active: false,
        },
        {
            level: 1,
            title: "Courses",
            icon: "stroke-learning",
            path: '/superadmin/courses',
            type: "link",
            active: false,
        },
        {
            level: 1,
            title: "Categories",
            icon: "stroke-bookmark",
            path: '/superadmin/categories',
            type: "link",
            active: false,
        },
        // {
        //     level: 1,
        //     title: "Tags",
        //     icon: "stroke-tag",
        //     path: '/superadmin/tags',
        //     type: "link",
        //     active: false,
        // },
        {
            level: 1,
            title: "Users",
            icon: "stroke-users",
            path: '/superadmin/users',
            type: "link",
            active: false,
        },
        {
            level: 1,
            title: "Packages",
            icon: "pricing-plan-dollar",
            path: '/superadmin/packages',
            type: "link",
            active: false,
        },
        {
            level: 1,
            title: "Banners",
            icon: "stroke-support-tickets",
            path: '/superadmin/banners',
            type: "link",
            active: false,
        },
    ];
    items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

    ngOnDestroy() {
        this.unsubscriber.complete();
    }
}
